export default __webpack_public_path__ + "static/media/image.efef4dd3.gif";